export default __webpack_public_path__ + "static/media/onRecording.59f253b9.svg";